<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Step 10: Payment</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top" [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell large-12 medium-12 small-12">
    <app-payments [active]="step == activeStep || reviewStates.includes(applicationState)" [config]="config?.permits?.documents" [form]="form" [authorization]="authorization" [allowExpedite]="allowExpedite" [fees]="fees" [organizationId]="organizationId" [organizationName]="organizationName" (authorizationRequested)="paymentAuthorizationRequested($event)" (checkPaymentSelected)="requestSave($event)" [parameters]="applicationPaymentParameters" (authorizationResponseReceived)="updateResponse($event)" (receiptIssued)="onReceiptIssued($event)"></app-payments>
  </div>
</div>